import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

// Kept apart from the page's DisableProvider, which needs the store, so leaf controls can read the read-only
// state without pulling the store into their imports.
export const DisableContext = createContext(true);

// Disables every field under it whatever the page's own state, keeping the page's setter. The condensed policy
// Details tab is read-only this way; edits go through the Make a change drawer.
// `readOnly={false}` passes the page's state through, so toggling it doesn't remount the children.
// `hideEditControls` also hides the add, remove and swap controls, for the read-only page view.
export const ReadOnlyProvider = ({ children, readOnly = true, hideEditControls = false }) => {
  const pageState = useContext(DisableContext);
  return (
    <DisableContext.Provider value={{ ...pageState, disabled: readOnly || pageState.disabled, hideEditControls }}>
      {children}
    </DisableContext.Provider>
  );
};

export const useHideEditControls = () => Boolean(useContext(DisableContext)?.hideEditControls);

// Renders an add, remove or swap control unless the read-only page view hides edit controls.
export const EditControl = ({ children }) => (useHideEditControls() ? null : children);

ReadOnlyProvider.propTypes = {
  children: PropTypes.node.isRequired,
  readOnly: PropTypes.bool,
  hideEditControls: PropTypes.bool
};

EditControl.propTypes = {
  children: PropTypes.node.isRequired
};
